import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { IListing, IListingsResponse, ListingsService, SeoService } from '@out-web/core';
import { ListingCardComponent } from '../../listing-card/listing-card.component';
import { ListingSkeletonComponent } from '../../../molecules/listing-skeleton/listing-skeleton.component';
import { PaginatorComponent } from '../../paginator/paginator.component';

@Component({
  selector: 'out-sale-pending-listing-portrait',
  standalone: true,
  imports: [
    CommonModule,
    ListingCardComponent,
    PaginatorComponent,
    ListingSkeletonComponent,
  ],
  providers: [ListingsService],
  templateUrl: './sale-pending-listing-portrait.component.html',
  styleUrl: './sale-pending-listing-portrait.component.scss',
})
export class SalePendingListingPortraitComponent implements OnInit {
  placeholderSkeletons = Array(9).fill(0);
  listings: IListing[] = [];
  @Input() paginateOnType?: string;
  @Input() pageResults = 0;
  @Input() skipResults = 0;

  currentPage = 0;
  isLoading = false;
  noListingsMessage = '';
  constructor(
    private seoService: SeoService,
    private listingsService: ListingsService
  ) { }

  ngOnInit(): void {
    this.setMetaData();
    this.loadListings();
    this.fetchFilters();
    this.fetchObservableStates();
  }
  private fetchObservableStates() {
    this.listingsService.listingsState$.subscribe((state) => {
      this.pageResults = state.totalListings;
    });
  }

  private setMetaData(): void {
    const title = 'Sale Pending Teslas | Sell Your Tesla | Only Used Tesla';
    const description = 'Explore Teslas with Sale Pending status. Only Used Tesla - A Marketplace Dedicated to Buying and Selling Used Teslas.';
    const imageUrl = 'https://onlyusedtesla.com/assets/images/meta-logo.png';
    const url = 'https://onlyusedtesla.com/categories/type/sale-pending';

    this.seoService.setMetaData(title, description, imageUrl, url);
  }

  private loadListings(): void {
    this.isLoading = true;
    this.listingsService
      .fetchListings({ listingType: 'SalePending' }, 'category')
      .subscribe({
        next: this.onListingsLoadSuccess.bind(this),
        error: this.onListingsLoadError.bind(this),
      });
  }

  private fetchFilters(): void {
    try {
      this.listingsService
        .fetchFilters({ listingType: 'SalePending' }, true)
        .subscribe();
    } catch (error) {
      console.error('Fetching filters error:', error);
    }
  }

  private onListingsLoadSuccess(data: IListingsResponse): void {
    this.listings = data.listings;
    this.isLoading = false;
    this.noListingsMessage =
      this.listings.length === 0 ? `No listings found.` : '';
  }

  private onListingsLoadError(error: HttpErrorResponse): void {
    this.isLoading = false;
    console.error('Error loading listings:', error);
  }

  onPaginationChange(skipNumber: number): void {
    this.listingsService.updateSkipListings(skipNumber);
    this.skipResults = skipNumber;
    // Load listings with updated skipResults
    this.loadListings();
  }
}
